import { render } from "./ModalNotesAdd.vue?vue&type=template&id=2cf74836&scoped=true"
import script from "./ModalNotesAdd.vue?vue&type=script&lang=js"
export * from "./ModalNotesAdd.vue?vue&type=script&lang=js"

import "./ModalNotesAdd.vue?vue&type=style&index=0&id=2cf74836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf74836"]])

export default __exports__